import { Component, HostListener, Input, OnChanges, OnDestroy } from '@angular/core';
import * as echarts from 'echarts';

@Component({
  selector: 'app-area-graph',
  templateUrl: './area-graph.component.html',
  styleUrls: ['./area-graph.component.scss']
})
export class AreaGraphComponent implements OnChanges, OnDestroy {
  chartOption: any;
  noData: boolean = false;
  private _intervalTimer: any;

  @Input() areaGraphData: any;
  @HostListener('window:resize', ['$event'])
  onResize() {
    let chart = echarts.init(document.getElementById('charts'));
    setTimeout(() => {
      chart.resize();
      // this.plotBar();
    }, 1);
  }
  constructor() { }
  
  ngOnDestroy(): void {
    this._clearTimer();
  }

  ngOnChanges(): void {
    if ((this.areaGraphData?.scheduledFrom && this.areaGraphData?.scheduledTo) && new Date(this.areaGraphData.scheduledTo) > new Date() ) {
      this.plotBar();
    }else{
      this.noData = true;
    }
  }


  /**
   * Generates time array for x axis
   * @returns  
   */
  generateTimeArray() {
    const times = [];
    const now = new Date();
    const start = new Date(now.setHours(0, 0, 0, 0)).getTime(); // Start of today
    const end = new Date(now.setHours(24, 0, 0, 0)).getTime(); // End of today
    for (let t = start; t <= end; t += 1000) { // Increment by 1 hour (1000 ms)
      times.push(new Date(t).toISOString());
    }
    return times;
  }

  /**
   * Generates time array for left area
   * @returns  
   */
  generateTimeArray1() {
    const times = [];
    const now = new Date();
    const start = new Date(now.setHours(0, 0, 0, 0)).getTime(); // Start of today
    const end = this.areaGraphData.warningStatus? new Date(this.areaGraphData?.modifiedDate).getTime() : new Date().getTime() ; //current time
    for (let t = start; t <= end; t += 1000) { // Increment by 1 second (1000 ms)
      if( t <= new Date(this.areaGraphData?.scheduledFrom).getTime()){
        times.push([new Date(t).toISOString(),null]);
      }else{
        if(t <= new Date(this.areaGraphData?.scheduledTo).getTime())
          times.push([new Date(t).toISOString(),100]); 
      }
    }
    return times;
  }

  /**
   * Generates time array for right area
   * @returns  
   */
  generateTimeArray2() {
    const times = [];
    const now = new Date();
    const start = this.areaGraphData.warningStatus? new Date(this.areaGraphData?.modifiedDate).getTime() : new Date().getTime() ; // Start of today
    const end = new Date(now.setHours(24, 0, 0, 0)).getTime(); // End of today
    for (let t = start; t <= end; t += 1000) { // Increment by 1 second (1000 ms)
      if (t <= new Date(this.areaGraphData?.scheduledTo).getTime() && t > new Date(this.areaGraphData?.scheduledFrom).getTime()){
        times.push([new Date(t).toISOString(), 100]);
      } else {
        times.push([new Date(t).toISOString(), null]);
      }
    }
    return times;
  }

  /**
   * Plots bar
   */
  plotBar() {
    const timeArray = this.generateTimeArray();
    const data1 = this.generateTimeArray1();
    const data2 = this.generateTimeArray2();
    this.chartOption = {
      tooltip: {
        triggerOn: 'none'
      },
      xAxis: {
        type: 'time',
        data: timeArray,
        axisTick: false,
        axisLabel: {
          formatter: function (value) {
            var date = new Date(value);
            var hours = date.getHours();
            var minutes = date.getMinutes();
            if(hours === 23 && minutes === 59)
            {
              hours = 24;
              minutes = 0;
            }
            return `${hours}:${minutes < 10 ? '0' + minutes : minutes}`;
          },
          showMinLabel: true,
          showMaxLabel: true
        },
        axisPointer: {
          value: new Date().toISOString(),
          lineStyle: {
            color: 'rgba(53, 96, 102, 1)',
            width: 2,
            type: 'solid',
            cap: 'round'
          },
          label: {
            show: true,
            formatter: function () {
              return '';
            },
            backgroundColor: 'rgba(53, 96, 102, 1)',
            borderRadius: 20,
            padding: [5, 5]
          },
          handle: {
            show: new Date().toISOString() > this.areaGraphData?.scheduledTo? false: true,
            size: 0
          }
        },
      },
      yAxis: {
        type: 'value',
        show: false, // Hide the Y-axis
        splitLine: { show: false }, // Hide Y-axis grid lines
        max: 120

      },
      grid: {
        top: 10,
        left: 15,
        right: 16,
        height: 100
      },
      series: [
        {
          name: 'First Part',
          data: data1, // Data points up to the 3rd point
          type: 'line',
          smooth: true,
          color: 'rgba(79, 134, 141, 1)',
          areaStyle: {
            color: 'rgba(79, 134, 141, 1)', // Color for the first part
            opacity: 1
          },
          showSymbol: false, // Hide symbols to prevent overlapping

        },
        {
          name: 'Second Part',
          data: data2, // Data points from the 4th point onwards
          type: 'line',
          smooth: true,
          color: 'rgba(219, 230, 231, 1)',
          areaStyle: {
            color: 'rgba(219, 230, 231, 1)', // Color for the second part
            opacity: 1
          },
          showSymbol: false // Hide symbols to prevent overlapping
        }
      ]
    };
    if(this.areaGraphData.warningStatus)
    {
      this.chartOption.xAxis.axisPointer.value = this.areaGraphData?.modifiedDate;
      this.chartOption.xAxis.axisPointer.lineStyle.color = 'rgba(237, 96, 77, 1)';
      this.chartOption.xAxis.axisPointer.label.backgroundColor = 'rgba(237, 96, 77, 1)';
    }else{
      this._startTimer();
    }
  }

  /**
   * Starts timer
   */
  private _startTimer() {
    this._clearTimer();
    this._intervalTimer = setInterval(() => {
      this.plotBar();
    }, 10000);
  }

  /**
   * Clears timer
   */
  private _clearTimer() {
    if (this._intervalTimer) {
      clearInterval(this._intervalTimer);
    }
  }
}
